import React from 'react';
import PropTypes from 'prop-types';
function ActionArea(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(React.Fragment, null, React.cloneElement(children, {
    onClick: onClick,
    style: {
      cursor: 'pointer'
    }
  }));
}
ActionArea.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content of the component. React component, node, text etc.
   */
  children: PropTypes.node.isRequired,
  /**
   * Function called when node is clicked
   */
  onClick: PropTypes.func.isRequired
} : {};
export default ActionArea;